angular.module('rjmNg.directives').directive "highlight", [
  "stringService"
  (stringService) ->
    restrict: "A"
    priority: 1000
    controller: [
      "$scope"
      "$attrs"
      ($scope, $attrs) ->
        @highlight = (text) ->
          search = $scope.$eval($attrs.highlight)
          if search is ""
            return text
          # Replace matches with $_$match$_$ place holder, then html encode to prevent script execution
          replacedMatches = text.replace(new RegExp(stringService.escapeRegEx(search), 'ig'), (match, $elm) ->
            return '$_$' + match + '$_$')
          htmlEncoded = $('<div />').text(replacedMatches).html()
          # Replace encoded html $_$ place holders with the strong tags
          result = htmlEncoded.replace(new RegExp(/\$\_\$.*?\$\_\$/, 'ig'), (match, $elm) ->
            return '<strong>' + match.slice(3, -3) + '</strong>')
          return result

        @
    ]
    link: (scope, elm, attrs, controller) ->
      scope.$watch attrs.highlight, (highlight, old) ->
        if highlight? and not (highlight is "" and old is "")
          elm.html(controller.highlight(elm.text()))
]
